export const AUTHTOKEN = 'AUTHTKN'
export const DOMAIN = '.controlac.com'

const constants = {
  AUTHTOKEN,
  DOMAIN
}

export default constants
